import { render, staticRenderFns } from "./CertSaveTJ.vue?vue&type=template&id=40d90ace&scoped=true&"
import script from "./CertSaveTJ.vue?vue&type=script&lang=js&"
export * from "./CertSaveTJ.vue?vue&type=script&lang=js&"
import style0 from "./CertSaveTJ.vue?vue&type=style&index=0&id=40d90ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d90ace",
  null
  
)

export default component.exports